import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles'
import { Icon } from '@iconify/react'
import { Typography, withStyles } from '@material-ui/core'
import { messageBoxShowAction } from 'src/reducers/message-box/action'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import CreditBalanceContent from 'src/components/credit-balance-content'
import MessageBoxContent from 'src/model/message-box'
import { userLimitsGetAction } from 'src/reducers/user-limits/action'
import {
  selectUserLimits,
  selectCurrentCredits,
} from 'src/reducers/user-limits/selector'
import clsx from 'clsx'
const CreditCountBadge = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const userLimits = useSelector(selectUserLimits)
  const currentCredits = useSelector(selectCurrentCredits)
  const isCoursePage = window.location.pathname.includes('/mini-course/')
  // Fetch user limits if not available
  useEffect(() => {
    if (!userLimits) {
      dispatch(userLimitsGetAction())
    }
  }, [dispatch, userLimits])

  const openCreditModal = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          title: `
            <Typography fontSize={16} fontWeight={400}>
              Your Account Balance
            </Typography>`,
          component: <CreditBalanceContent />,
          buttons: [],
          maxWidth: '600px',
        }),
      ),
    )
  }

  return (
    <div
      className={clsx(classes.root, {
        [classes.coursePage]: isCoursePage,
      })}
      onClick={openCreditModal}
    >
      <Icon
        icon="mage:coin-a"
        style={{
          color: '#015ffb',
        }}
      />
      <Typography fontSize={14} fontWeight={400} color="primary">
        {currentCredits} Credits
      </Typography>
    </div>
  )
}

export default withStyles(styles)(CreditCountBadge)
